import { TimelineLite, Power4 } from 'gsap/TweenMax';
import { qs, isMobile } from '@/scripts/utils';

export const museletLoaderIn = (el) => {
  const muselet = qs('.muselet__dot', el);
  const logo = qs('.logo-winary', el);

  const tl = new TimelineLite();

  tl
    .to(logo, 0.6, {
      autoAlpha: 0,
      delay: 0.3,
    })
    .fromTo(muselet, 1.8, {
      scale: 0.3,
    }, {
      scale: 1,
      ease: Power4.easeInOut,
      clearProps: 'all',
    });

  return tl;
};

export const museletIn = (el) => {
  const muselet = qs('.muselet__dot', el);

  const artwork = qs('.artwork', el);

  const tl = new TimelineLite();

  tl
    .add('start')
    .to(muselet, 1.4, {
      scale: 1,
      x: 0,
      y: 0,
      xPercent: 0,
      yPercent: 0,
      ease: Power4.easeInOut,
      clearProps: 'all',
    }, 'start')
    .to(artwork, 1.4, {
      scale: 1,
      x: 0,
      y: 0,
      xPercent: -50,
      yPercent: -50,
      ease: Power4.easeInOut,
    }, 'start+=0.1');

  return tl;
};

export const museletOut = (el) => {
  const view = qs('[js-view]', el).getAttribute('js-view');

  const muselet = qs('.muselet__dot', el);
  const artwork = qs('.artwork', el);

  const contW = qs('[js-pagecontainer]', el).getBoundingClientRect().width;
  const contH = qs('[js-pagecontainer]', el).getBoundingClientRect().height;
  // const windowW = window.innerWidth;

  const tXm = !isMobile() ? (contW - (muselet.getBoundingClientRect().width * 0.8)) / 2 : 0;
  const tYm = isMobile() ? ((contH - (muselet.getBoundingClientRect().height * 1.4)) / 2) + (muselet.getBoundingClientRect().height) : 0; // eslint-disable-line
  const tXa = (contW - (artwork.getBoundingClientRect().width * 0.8)) / 2;
  const tYa = isMobile() ? ((contH - (artwork.getBoundingClientRect().height * 0.8)) / 2) + (artwork.getBoundingClientRect().height / 5.5) : 0; // eslint-disable-line

  // const tXmP = isMobile() ? 0 : ((100 * tXm) / windowW) + 20;
  // const tXaP = isMobile() ? -50 : ((100 * tXa) / windowW) - (0.8 * 50);

  let scaleM = 0.8;
  // let tYmP = 0;
  // let tYap = -50;

  const tl = new TimelineLite();

  if (isMobile() && view === 'event') {
  //   tYmP = -120;
    scaleM = 1.4;

  //   tYap = -105;
  }

  tl
    .add('start')
    .to(muselet, 1.4, {
      x: tXm,
      y: -tYm,
      scale: scaleM,
      ease: Power4.easeInOut,
    }, 'start')
    .to(artwork, 1.4, {
      scale: 0.8,
      x: tXa,
      y: -tYa,
      ease: Power4.easeInOut,
    }, 'start+=0.1');

  return tl;
};



// WEBPACK FOOTER //
// ./src/scripts/timelines/museletTransitions.js